(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name configureTrackingColor.controller:ConfigureTrackingColorCtrl
   *
   * @description
   *
   */
  angular
    .module('configureTrackingColor')
    .controller('ConfigureTrackingColorCtrl', ConfigureTrackingColorCtrl);


  function ConfigureTrackingColorCtrl(ConfigureTrackingColorService,MessageService) {
    var vm = this;
    vm.ctrlName = 'ConfigureTrackingColorCtrl';


    vm.model = {
            initialSearchDone: false,
            searchCriteria:{
                type:null
            },
            colorList:[],
            masterList:{
                typeList:[]

            },
            isElasticLoadingVisible:false
        };

    vm.searchColors = function () {
        if(vm.model.searchCriteria.type!==null){
            vm.model.colorList = [];
            vm.model.initialSearchDone=true;
            ConfigureTrackingColorService.setSearchCriteria(vm.model.searchCriteria);
            ConfigureTrackingColorService.getTrackingColors(
            		function (typeList) {
                        updateColors(typeList);
                    },
                    function (error) {
                        MessageService.error(error);
                    }
                );
        }
    };

    vm.onChanges = function (selectedItems) {
    		ConfigureTrackingColorService.saveColor(selectedItems,
    		function (response) {
    			if(response.success){
    				selectedItems= null
                }else{
                	selectedItems= null
                }

    		},function (error) {
           //    MessageService.error(error);
            }

    	);
    }

    function updateColors(colors){
      angular.forEach(colors, function (color) {
        vm.model.colorList.push(color);
       });
       vm.model.isElasticLoadingVisible= false;
    }


    function setDefault() {
        vm.model.masterList.typeList = ConfigureTrackingColorService.searchTypes();

    }

    setDefault();
  }
}());
